import { MouseEvent, useState } from "react";
import styles from "./ToggleButton.module.css";

interface ToggleButtonProps {
    isOn: boolean;
    onToggle: (data: FormData) => void;
}

const ToggleButton = (props: ToggleButtonProps) => {
    const [isOn, setIsOn] = useState(props.isOn);

    const handleToggle = (e: MouseEvent<HTMLElement>) => {
        setIsOn(!isOn);
        const formData = new FormData();
        formData.set("emailNotification", String(Number(!isOn)));
        props.onToggle(formData);
    };

    return (
        <div onClick={handleToggle} className={styles.container}>
            <div className={`${styles.wrapper} ${isOn ? styles.on : ""}`}></div>
            <div className={`${styles.circle} ${isOn ? styles.on : ""}`}></div>
        </div>
    );
};

export default ToggleButton;
